// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__21nv0","title":"styles_title__17rzP","text":"styles_text__Uqql5"};